import React from 'react';
import BackupSection from '../Backup/BackupSection';
import './SettingsTab.scss';

/**
 * BackupTab
 *
 * The dedicated Cloud Backup page (avatar menu → "Cloud Backup", or the
 * pointer row in Settings). Same scroller/content shell as SettingsTab so
 * the scrollbar sits at the window edge; the section itself is the full
 * backup surface: status hero, storage meter, per-app cards, config,
 * failure review, and restore.
 */
function BackupTab() {
    return (
        <div className="settings-tab">
            <div className="settings-content" style={{ maxWidth: 600, margin: '0 auto', padding: '36px 24px 64px', color: 'var(--color-text-primary)' }}>
                <div style={{ textAlign: 'center', marginBottom: 28 }}>
                    <h2 style={{ margin: 0, fontSize: 26, fontWeight: 700 }}>Cloud Backup</h2>
                    <p style={{ margin: '8px 0 0', fontSize: 14, color: 'var(--color-text-tertiary)' }}>
                        Your files, cues and playlists — safe, and restorable anywhere.
                    </p>
                </div>
                <BackupSection standalone />
            </div>
        </div>
    );
}

export default BackupTab;
